import DEMO_GAME from './games/demo.js';
import TWO_PLAYER_GAME from './games/twoPlayer.js';

const GAME_LIBRARY = new Map([
  DEMO_GAME,
  TWO_PLAYER_GAME,
].map((game) => [game.identifier, game]));
export default GAME_LIBRARY;
